import React, { FC } from 'react';

import Payment from '~/components/views/payment';

const PaymentPage: FC = () => {
  return <Payment />;
};

export default PaymentPage;
